module.exports = {
          srcSet: __webpack_public_path__ + "c60cf2c67217c0f4d31bebb33e36a828-488.png"+" 488w",
          images:[ {path: __webpack_public_path__ + "c60cf2c67217c0f4d31bebb33e36a828-488.png",width: 488,height: 470}],
          src: __webpack_public_path__ + "c60cf2c67217c0f4d31bebb33e36a828-488.png",
          toString:function(){return __webpack_public_path__ + "c60cf2c67217c0f4d31bebb33e36a828-488.png"},
          
          width: 488,
          height: 470
        }